interface IProps {
  display : string;
}



const Watermark = ({display} : IProps) => {
    return (
      <div className="watermark" style={ {display : display}}>
        REGISTRO HISTÓRICO
      </div>
    );
  };
  
  export default Watermark;
  